const initialState = {
    showSuccessToast:false,
    showTokenizerErrorToast:false,
    showApiErrorToast:false,
    showMemoApiErrorToast:false,
    showScriptErrorToast:false,
    showCyberSourceErrorToast:false,
    showNoWalletEventErrorToast:false,
    showGenericErrorToast:false,
    showTnCErrorToast: false
};

const ToastReducer  = (state=initialState,action) => {
    switch(action.type){
        case 'SET_SUCCESS_TOAST':{
            return  {
                ...state,
                showSuccessToast:action.value,
                showTokenizerErrorToast:false,
                showApiErrorToast:false,
                showScriptErrorToast:false,
                showCyberSourceErrorToast:false,
                showTnCErrorToast: false,
                showMemoApiErrorToast:false
            }
        }
        case 'SET_TOKENIZER_ERROR_TOAST':{
            return  {
                ...state,
                showTokenizerErrorToast:action.value,
                showSuccessToast:false,
                showApiErrorToast:false,
                showScriptErrorToast:false,
                showCyberSourceErrorToast:false,
                showTnCErrorToast: false,
                showMemoApiErrorToast:false
            }
        }
        case 'SET_API_ERROR_TOAST':{
            return{
                ...state,
                showApiErrorToast:action.value,
                showTokenizerErrorToast:false,
                showSuccessToast:false,
                showScriptErrorToast:false,
                showCyberSourceErrorToast:false,
                showTnCErrorToast: false,
                showMemoApiErrorToast:false
            }
        }
        case 'SET_MEMO_API_ERROR_TOAST':{
            return{
                ...state,
                showMemoApiErrorToast:action.value,
                showApiErrorToast:false,
                showTokenizerErrorToast:false,
                showSuccessToast:false,
                showScriptErrorToast:false,
                showCyberSourceErrorToast:false,
                showTnCErrorToast: false
            }
        }
        case 'SET_SCRIPT_ERROR_TOAST':{
            return{
                ...state,
                showScriptErrorToast:action.value,
                showApiErrorToast:false,
                showTokenizerErrorToast:false,
                showSuccessToast:false,
                showCyberSourceErrorToast:false,
                showTnCErrorToast: false,
                showMemoApiErrorToast:false
            }
        }
        case 'SET_CYBER_SOURCE_ERROR_TOAST':{
            return{
                ...state,
                showCyberSourceErrorToast:action.value,
                showScriptErrorToast:false,
                showApiErrorToast:false,
                showTokenizerErrorToast:false,
                showSuccessToast:false,
                showTnCErrorToast: false,
                showMemoApiErrorToast:false
            }
        }
        case 'SET_NO_WALLET_EVENT_ERROR_TOAST':{
            return{
                ...state,
                showNoWalletEventErrorToast:action.value,
                showCyberSourceErrorToast:false,
                showScriptErrorToast:false,
                showApiErrorToast:false,
                showTokenizerErrorToast:false,
                showSuccessToast:false,
                showTnCErrorToast: false,
                showMemoApiErrorToast:false
            }
        }
        case 'SET_GENERIC_ERROR_TOAST':{
            return{
                ...state,
                showGenericErrorToast:action.value,
                showCyberSourceErrorToast:false,
                showScriptErrorToast:false,
                showApiErrorToast:false,
                showTokenizerErrorToast:false,
                showSuccessToast:false,
                showTnCErrorToast: false,
                showMemoApiErrorToast:false
            }
        }
        case 'SET_TNC_ERROR_TOAST': {
            return{
                ...state,
                showTnCErrorToast: action.value,
                showCyberSourceErrorToast:false,
                showScriptErrorToast:false,
                showApiErrorToast:false,
                showTokenizerErrorToast:false,
                showSuccessToast:false,
                showMemoApiErrorToast:false
            }
        }
        default:
            return state;
    }

};

export default ToastReducer;
